"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeContext = void 0;
var React = require("react");
exports.ThemeContext = React.createContext({});
//# sourceMappingURL=context.js.map